export interface IRecommendationsResponse {
	productIds: string[];
	uuid?: string;
	recommenderName?: string;
}
export enum ERecommendationsProviders {
	EINSTEIN = 'einstein',
	SFCC = 'sfcc'
}
export enum ERecommendationsTypes {
	RECENTLY_VIEWED = 'viewed-recently' as any,
	YOU_MAY_ALSO_LIKE = 'product-to-product' as any,
	COMPLETE_THE_SET = 'complete-the-set' as any,
	RECOMMENDED_PRODUCTS = 'products-in-a-category' as any,
	RECOMMENDED_PRODUCTS_TWO = 'products-in-a-category-two' as any,
	RECOMMENDED_PRODUCTS_FULL_PRICE = 'products-in-all-categories-FULL-PRICE',
	RECOMMENDED_PRODUCTS_SALE = 'products-in-all-categories-SALE',
	PRODUCT_TO_PRODUCT_THREE = 'product-to-product-three',
	SHOP_THE_LOOK = 'shop-the-look' as any,
	OTHER = 'other' as any,
}
